<template>
  <div class="client-details" @keydown.enter.stop.prevent="save">
    <p class="client-form-help">Stačia základné údaje klienta. Hypotéku ani jej účel teraz nezadávate.</p>
    <div v-for="field in fields" :key="field.key" class="input-group">
      <label :for="`${formId}-${field.key}`" class="field-label">{{ field.label }}</label>
      <input ref="fields" form="" :id="`${formId}-${field.key}`" v-model="form[field.key]" :type="field.type"
        :required="field.required" :disabled="saving" :autocomplete="field.autocomplete"
        class="text-input w-input" :maxlength="field.key === 'telephone' ? 32 : 150" />
    </div>
    <p v-if="error" class="clientError" role="alert">{{ error }}</p>
    <div class="client-actions">
      <button type="button" class="client-save" :disabled="saving" @click="save">{{ saving ? 'Ukladám…' : client ? 'Uložiť údaje' : 'Vytvoriť klienta' }}</button>
      <button type="button" class="client-cancel" :disabled="saving" @click="$emit('cancel')">Späť</button>
    </div>
  </div>
</template>

<script>
import { createTempUser, getClientById, patchClient, patchClientProfile, patchUserProfileByID } from '@/services/brokerService';

export default {
  name: 'ClientDetailsForm',
  props: { client: Object, brokerId: Number },
  data() {
    return {
      savedId: this.client?.id || null,
      saving: false,
      error: '',
      formId: `client-details-${this._uid}`,
      form: {
        first_name: this.client?.first_name || '',
        last_name: this.client?.last_name || '',
        email: this.client?.email?.includes('@nomail.bankari.sk') ? '' : this.client?.email || '',
        telephone: this.client?.client_profile?.telephone || '',
      },
      fields: [
        { key: 'first_name', label: 'Meno', type: 'text', required: true, autocomplete: 'given-name' },
        { key: 'last_name', label: 'Priezvisko', type: 'text', required: true, autocomplete: 'family-name' },
        { key: 'email', label: 'Email (voliteľné)', type: 'email', autocomplete: 'email' },
        { key: 'telephone', label: 'Telefón (voliteľné)', type: 'tel', autocomplete: 'tel' },
      ],
    };
  },
  methods: {
    async save() {
      if (this.saving) return;
      this.error = '';
      if ((this.$refs.fields || []).some(input => !input.reportValidity())) return;
      if (!this.form.first_name.trim() || !this.form.last_name.trim()) {
        this.error = 'Vyplňte meno a priezvisko klienta.';
        return;
      }
      this.saving = true;
      this.$emit('busy', true);
      try {
        // Keep the ID after a partial failure so retrying never creates another client.
        if (!this.savedId) this.savedId = (await createTempUser()).data.id;
        const client = await getClientById(this.savedId, 'client_profile');
        const user = { first_name: this.form.first_name.trim(), last_name: this.form.last_name.trim() };
        if (this.form.email.trim()) user.email = this.form.email.trim();
        await patchUserProfileByID(this.savedId, user);
        await patchClientProfile({ telephone: String(this.form.telephone).trim() || null }, client.client_profile.id);
        const brokerId = this.brokerId || (this.$store.getters['userState/getRole'] === 'financnik' ? this.$store.getters['userState/getId'] : null);
        if (!this.client && brokerId) await patchClient(this.savedId, { financnik: brokerId });
        this.$emit('saved', await getClientById(this.savedId, 'client_profile'));
      } catch (error) {
        const data = error?.response?.data;
        const detail = data?.detail || (data && Object.values(data)[0]);
        this.error = (Array.isArray(detail) ? detail.join(' ') : typeof detail === 'string' ? detail : '')
          || 'Klienta sa nepodarilo uložiť. Skontrolujte údaje a skúste to znova.';
      } finally {
        this.saving = false;
        this.$emit('busy', false);
      }
    },
  },
};
</script>

<style scoped>
.client-details { margin: 16px 0; color: var(--app-text, #0a1953); }
.client-form-help { margin: 0 0 16px; font-size: 12px; line-height: 1.6; color: var(--app-text-muted, #6f7f96); }
.client-details .input-group { position: relative; margin-bottom: 12px; }
.client-details .field-label { left: 20px; top: 12px; margin: 0; font-size: 12px; color: var(--app-text-muted, #6f7f96); }
.client-details .text-input { width: 100%; min-height: 72px; padding: 32px 20px 13px; margin: 0; border: 1px solid var(--app-border, #dce5f0); border-radius: 18px; font-size: 15px; line-height: 1.5; box-sizing: border-box; }
.client-actions { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-top: 18px; }
.client-save, .client-cancel { min-height: 44px; padding: 12px 18px; border-radius: 12px; font-size: 13px; font-weight: 700; line-height: 1.5; cursor: pointer; }
.client-save { background: #286cb2; border: 1px solid #286cb2; color: #fff; flex: 1; }
.client-save:hover:not(:disabled) { background: #215a95; }
.client-cancel { color: var(--app-text, #0a1953); border: 1px solid var(--app-border, #dce5f0); background: var(--app-surface, #fff); }
.client-details button:focus-visible, .client-details input:focus-visible { outline: 2px solid var(--app-primary, #286cb2); outline-offset: 3px; }
button:disabled { opacity: .55; cursor: default; }
</style>
